export const BUTTONACTIVE = "#f3d9b1";
export const BUTTONINACTIVE = "rgba(10, 10, 10, 0.806)";
export const BUTTONACTIVETEXTCOLOR = "black";
export const BUTTONINACTIVETEXTCOLOR = "white";
